import loadable from '@loadable/component';

const LoadableKeystoneRunContent = loadable(() => import('./keystoneRunContent'));

export default LoadableKeystoneRunContent;
